export const ShipmentContract  = {
    
    async ptl_get_orders_pendings(shipping_service) {
        shipping_service;

        throw new Error("shipments ptl_get_orders_pendings not implemented");
    },
     
    async ptl_get_confirmed_orders(shipping_service) {
        shipping_service;

        throw new Error("shipments ptl_get_confirmed_orders not implemented");
    },
     
    async ptl_get_supplied_orders(shipping_service) {
        shipping_service;

        throw new Error("shipments ptl_get_supplied_orders not implemented");
    },
     
    async ptl_get_sent_orders(shipping_service) {
        shipping_service;

        throw new Error("shipments ptl_get_sent_orders not implemented");
    },
     
    async ptl_get_returned_orders(shipping_service) {
        shipping_service;

        throw new Error("shipments ptl_get_returned_orders not implemented");
    },
     
    async ptl_show_order_info(id) {
        id;

        throw new Error("shipments ptl_show_order_info not implemented");
    },
     
    async ptl_delete_order(id) {
        id;

        throw new Error("shipments ptl_delete_order not implemented");
    },
     
    async ptl_prepare_orders(order_ids) {
        order_ids;

        throw new Error("shipments ptl_prepare_orders not implemented");
    },
     
    async ptl_release_orders(trace_id) {
        trace_id;

        throw new Error("shipments ptl_release_orders not implemented");
    },
     
    async ptl_get_order_by_tote(tote) {
        tote;

        throw new Error("shipments ptl_get_order_by_tote not implemented");
    },
     
    async ptl_get_label(data) {
        data;

        throw new Error("shipments ptl_get_label not implemented");
    },

    async index_pendings(url, page, per_page, search, shipping_service) {
        url;
        page;
        per_page;
        search;
        shipping_service;

        throw new Error("shipments index not implemented");
    },

    async get_aff_index_orders(status, page, per_page, search, sort_by, shipping_service) {
        status;
        page;
        per_page;
        search;
        sort_by;
        shipping_service;

        throw new Error("shipments get_aff_index_orders not implemented");
    },

    async aff_scan_identifier(transaction_id, identifier) {
        transaction_id;
        identifier;

        throw new Error("shipments aff_scan_identifier not implemented");
    },

    async aff_get_products_by_order(id) {
        id;

        throw new Error("shipments aff_get_products_by_order not implemented");
    },

    async get_ff_shipping_services(shipping_service) {
        shipping_service; 
        
        throw new Error("shipments get_ff_shipping_services not implemented");
    },
}